import createAsyncActions from 'shared/redux/helpers/create-async-actions';
import vodAdapter from 'shared/utils/adapters/vod';

import { normalizeVideo } from 'shared/redux/helpers/normalized';


const ACTIONS = createAsyncActions('SERVER.VIDEO.GET');
export const NAMES = ACTIONS.NAMES;
const { START, SUCCESS, FAIL } = ACTIONS;


export default function (id) {
  return function (dispatch) {
    const params = { id };
    dispatch(START(params));

    const promise = vodAdapter.item.get(id);

    return promise
      .then(
        function (response) {
          response = {
            ...response,
            data: normalizeVideo(response.data),
          };

          dispatch(SUCCESS(params, response));
          return response;
        },

        function (response) {
          dispatch(FAIL(params, response, { analytics: { type: 'error', name: 'dashboard.video.get' } }));
        }
      );
  };
}



// WEBPACK FOOTER //
// ./src/dashboard/redux/server/actions/video/get.js